import RwcAnalyticsLayout from './RwcAnalyticsLayout.component';

export default RwcAnalyticsLayout;